export default [
  {
    path: '/createAdmin',
    name: 'CreateAdmin',
    component: () => import('./Admin.vue'),
    meta: {title: '新增用户'},
  },
  {
    path: '/admins',
    name: 'Admins',
    component: () => import('./Admins.vue'),
    meta: {title: '用户管理'},
  },
  {
    path: '/admins/:id',
    name: 'UpdateAdmin',
    component: () => import('./Admin.vue'),
    meta: {title: '编辑用员'},
  },
]
